/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SoHeaderAppointmentListItemModelPagedListData } from '../models/SoHeaderAppointmentListItemModelPagedListData';
import type { WipAppointmentPreparationCheckTypeModel } from '../models/WipAppointmentPreparationCheckTypeModel';
import type { WipAppointmentPreparationEditModel } from '../models/WipAppointmentPreparationEditModel';
import type { WipAppointmentPreparationLogModelPagedListData } from '../models/WipAppointmentPreparationLogModelPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WipAppointmentPreparationService {

  /**
   * @param page 
   * @param pageSize 
   * @param branchId 
   * @param deptCode 
   * @param dateFrom 
   * @param dateTo 
   * @param bookingType 
   * @param customerService 
   * @param ownerId 
   * @param wipNo 
   * @param regNo 
   * @returns SoHeaderAppointmentListItemModelPagedListData Success
   * @throws ApiError
   */
  public static getWipAppointmentPreparation(
page?: number,
pageSize?: number,
branchId?: number,
deptCode?: string,
dateFrom?: string,
dateTo?: string,
bookingType?: number,
customerService?: number,
ownerId?: number,
wipNo?: number,
regNo?: string,
): CancelablePromise<SoHeaderAppointmentListItemModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wip-appointment-preparation',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'BranchId': branchId,
        'DeptCode': deptCode,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'BookingType': bookingType,
        'CustomerService': customerService,
        'OwnerId': ownerId,
        'WipNo': wipNo,
        'RegNo': regNo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postWipAppointmentPreparation(
requestBody?: WipAppointmentPreparationEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-appointment-preparation',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param page 
   * @param pageSize 
   * @param branchId 
   * @param deptCode 
   * @param dateFrom 
   * @param dateTo 
   * @param bookingType 
   * @param customerService 
   * @param ownerId 
   * @param wipNo 
   * @param regNo 
   * @returns WipAppointmentPreparationLogModelPagedListData Success
   * @throws ApiError
   */
  public static getWipAppointmentPreparationLog(
page?: number,
pageSize?: number,
branchId?: number,
deptCode?: string,
dateFrom?: string,
dateTo?: string,
bookingType?: number,
customerService?: number,
ownerId?: number,
wipNo?: number,
regNo?: string,
): CancelablePromise<WipAppointmentPreparationLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wip-appointment-preparation/log',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'BranchId': branchId,
        'DeptCode': deptCode,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'BookingType': bookingType,
        'CustomerService': customerService,
        'OwnerId': ownerId,
        'WipNo': wipNo,
        'RegNo': regNo,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns number Created
   * @throws ApiError
   */
  public static postWipAppointmentPreparationBySoheaderId(
soHeaderId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-appointment-preparation/{soHeaderId}/by-soheader-id',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static getWipAppointmentPreparation1(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wip-appointment-preparation/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putWipAppointmentPreparation(
id: number,
requestBody?: WipAppointmentPreparationEditModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/wip-appointment-preparation/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchWipAppointmentPreparation(
id: number,
requestBody?: WipAppointmentPreparationEditModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/wip-appointment-preparation/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWipAppointmentPreparationCompletePreparation(
id: number,
requestBody?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-appointment-preparation/complete-preparation/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @param soHeaderId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postWipAppointmentPreparationRecallJob(
id: number,
userId?: number,
soHeaderId?: number,
requestBody?: Array<number>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/wip-appointment-preparation/{id}/recall-job',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
        'soHeaderId': soHeaderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns WipAppointmentPreparationCheckTypeModel Success
   * @throws ApiError
   */
  public static getWipAppointmentPreparationCheckTypes(): CancelablePromise<Array<WipAppointmentPreparationCheckTypeModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wip-appointment-preparation/check-types',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static patchWipAppointmentPreparationChecks(
id: number,
requestBody?: Array<number>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/wip-appointment-preparation/{id}/checks',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
